import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

import { Typography } from '@sravni/react-design-system';

import { LIST_BY_RUBRICS } from '../../../constants/routes';
import { BottomMenuLink, TRubricType } from '../../../interfaces/news';
import { createLinkProps } from '../../../utils/routing';
import styles from '../left-column.module.scss';

// import { SubscriptionLink } from './SubscriptionLink';

const listRubricLink = (value: TRubricType) =>
  createLinkProps('list', LIST_BY_RUBRICS, {
    rubric: value,
  });

const renderBottomMenuItem = (item: BottomMenuLink) => (
  <Typography.Text
    size={12}
    key={item.name}
    className={classNames(styles.bottomLink, { [styles[`bottomLink--active`]]: item.isActive })}
  >
    {item.isExternal ? (
      <Typography.Link color={'dark'} href={item.url} {...item.otherProps}>
        {item.name}
      </Typography.Link>
    ) : (
      <Link href={item.link.href} as={item.link.as}>
        <Typography.Link color={'dark'} {...item.otherProps}>
          {item.name}
        </Typography.Link>
      </Link>
    )}
  </Typography.Text>
);

interface BottomMenuProps {
  subscriptionPopupState: [number, (value: number) => void];
}

export const BottomMenu = ({
  // subscriptionPopupState
}: BottomMenuProps) => {
  const { query } = useRouter();
  const { rubric, rubricAlias } = query;

  const bottomMenu: BottomMenuLink[] = [
    {
      name: 'Новости компаний',
      link: listRubricLink('novosti-partnerov'),
      isActive: rubric === 'novosti-partnerov' || rubricAlias === 'novosti-partnerov',
      otherProps: {},
      isExternal: false,
    },
    {
      name: 'Разместить рекламу',
      url: '/about/mediakit/',
      isActive: false,
      otherProps: {},
      isExternal: true,
    },
    {
      name: 'Предложить статью',
      url: '/article-proposal/',
      isActive: false,
      otherProps: {},
      isExternal: true,
    },
    {
      name: 'Наши эксперты',
      url: '/u/rating/',
      otherProps: {},
      isActive: false,
      isExternal: true,
    },
  ];

  return (
    <>
      {bottomMenu.map((menuItem) => renderBottomMenuItem(menuItem))}
      {/*<SubscriptionLink subscriptionPopupState={subscriptionPopupState} />*/}
    </>
  );
};
